'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useRouteOpen } from './use-route-open';

const MobileCategoriesContext = createContext<ReturnType<typeof useRouteOpen> | null>(null);

/** The sidebar shortcut and bottom tab open the same category view. */
export function MobileCategoriesProvider({ children }: { children: ReactNode }) {
  const state = useRouteOpen();
  return (
    <MobileCategoriesContext.Provider value={state}>{children}</MobileCategoriesContext.Provider>
  );
}

export function useMobileCategories() {
  const state = useContext(MobileCategoriesContext);
  if (!state) throw new Error('MobileCategoriesProvider is required');
  return state;
}
